import { useEffect, useRef, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tour, ConfigProvider } from 'antd';
import { tourEnded, tourStepChanged } from '../../redux/actions';
import './app-tour.css'

const AppTour = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const tourRef = useRef(null);

  const isTransitioningRef = useRef(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const { isActive, currentStep } = useSelector((s) => s.tour || {});
  const user = useSelector((s) => s.user);

  const [localOpen, setLocalOpen] = useState(Boolean(isActive));

  const tourSteps = {
    '/service': [
      {
        title: 'Готовы попробовать наш свежий микс?',
        description: 'Познакомим Вас с рецептом приготовления!',
        target: () => document.querySelector('#root'),
        placement: 'center',
        type: 'default',
      },
      {
        title: 'Импорт настроек',
        description: 'Возьмите готовый файл с настройками или создайте свои.',
        target: () => document.querySelector('#tour-item-service-import-data'),
        placement: 'right',
        type: 'default',
      },
    ],
	'/settings/company': [
      {
        title: 'Настройки',
        description: 'Укажите данные компании!',
        target: () => document.querySelector('#tour-item-nav-menu-settings'),
        placement: 'right',
        type: 'default',
      },
    ],
	'/settings/products': [
      {
        title: 'Настройки справочников',
        description: 'Заполните справочники товаров, услуг, абонементов и пакетов.',
        target: () => document.querySelector('#tour-item-nav-menu-dict-products'),
        expandParentId: '#tour-item-nav-menu-dicts',
        placement: 'bottom',
        type: 'default',
      },
      {
        title: 'Удобный ввод',
        description: 'Для ускорения ввода используйте сканер!',
        target: () => document.querySelector('#tour-item-settings-products-scanner'),
        placement: 'bottom',
        type: 'default',
      },
    ],
    '/settings/paymentvids': [
      {
        title: 'Настройки касс',
        description: 'Добавьте виды касс для приема платежей.',
        target: () => document.querySelector('#tour-item-nav-menu-dict-paymentvids'),
        expandParentId: '#tour-item-nav-menu-dicts',
        placement: 'bottom',
        type: 'default',
      },
    ],
    '/settings/rooms': [
      {
        title: 'Настройки залов',
        description: 'Настройте список залов, кабинетов и оборудования.',
        target: () => document.querySelector('#tour-item-nav-menu-dict-rooms'),
        expandParentId: '#tour-item-nav-menu-dicts',
        placement: 'bottom',
        type: 'default',
      },
      {
        title: 'Настройки залов',
        description: 'Загрузите значки для визуализации.',
        target: () => document.querySelector('#tour-item-settings-rooms-image-0'),
        placement: 'right',
        type: 'default',
      },
	 ],
    '/settings/cards': [
      {
        title: 'Настройки карт',
        description: 'Добавьте карты клиентов и настройте их для быстрого поиска.',
        target: () => document.querySelector('#tour-item-nav-menu-dict-cards'),
        expandParentId: '#tour-item-nav-menu-dicts',
        placement: 'bottom',
        type: 'default',
      },
      {
        title: 'Все готово!',
        description: 'Можно начинать работу!',
        target: () => document.querySelector('#root'),
        placement: 'center',
        type: 'default',
      }, 
    ],
    '/settings/users': [
	  {
        title: 'Настройки сотрудников',
        description: 'Сформируйте перечень сотрудников компании и добавьте логин пользователя.',
        target: () => document.querySelector('#tour-item-settings-menu-users'),
        placement: 'bottom',
        type: 'default',
      },
    ],
    '/settings/calendars': [
      {
        title: 'Настройки расписания',
        description: 'Создайте расписание и календари для сотрудников, кабинетов, абонементов.',
        target: () => document.querySelector('#tour-item-settings-menu-calendars'),
        placement: 'bottom',
        type: 'default',
      },
    ],
    '/clients': [
      {
        title: 'Работа с клиентами',
        description: 'Формируйте и просматривайте клиентскую базу.',
        target: () => document.querySelector('#tour-item-nav-menu-clients'),
        placement: 'right',
        type: 'default',
      },
      {
        title: 'Работа с клиентами',
        description: 'Используйте сканер для карт и камеру для фото!',
        target: () => document.querySelector('#tour-item-clients-scan-button'),
        placement: 'right',
        type: 'default',
      },
    ],
    '/records': [
      {
        title: 'Работа с записями',
        description: 'Вносите предварительные записи! Применяйте запись в резерв.',
        target: () => document.querySelector('#tour-item-nav-menu-records'),
        placement: 'right',
        type: 'default',
      },
      {
        title: 'Работа с записями',
        description: 'А также используйте смарт-запись на несколько услуг подряд!',
        target: () => document.querySelector('#tour-item-records-smart-record-button'),
        placement: 'right',
        type: 'default',
      },
    ],
    '/visits': [
      {
        title: 'Работа с визитами',
        description: 'Открывайте визиты клиентам по записи и абонементам.',
        target: () => document.querySelector('#tour-item-nav-menu-visits'),
        placement: 'right',
        type: 'default',
      },
      {
        title: 'Работа с визитами',
        description: 'Используйте сканер для поиска!',
        target: () => document.querySelector('#tour-item-visits-scan-button'),
        placement: 'right',
        type: 'default',
      },
    ],
    '/payments': [
      {
        title: 'Журналы',
        description: 'Просматривайте оплаты, продажи и другие журналы работы.',
        target: () => document.querySelector('#tour-item-nav-menu-journals'),
        placement: 'right',
        type: 'default',
      },
    ],
    '/stock': [
      {
        title: 'Склад',
        description: 'Внесите остатки и начните складской учет товаров!',
        target: () => document.querySelector('#tour-item-nav-menu-stock'),
        placement: 'right',
        type: 'default',
      },
    ],
    '/dialogs': [
      {
        title: 'Диалоги',
        description: 'Общайтесь с клиентами в чате и мессенджерах внутри платформы.',
        target: () => document.querySelector('#tour-item-nav-menu-messages'),
        placement: 'right',
        type: 'default',
      },
    ],
    '/reports': [
      {
        title: 'Работа с отчетами',
        description: 'Контролируйте качество с помощью различных отчетов!',
        target: () => document.querySelector('#tour-item-nav-menu-reports'),
        placement: 'right',
        type: 'default',
      },
    ],
    '/': [
      {
        title: 'Дашборд',
        description: 'Следите за процессом и его показателями!',
        target: () => document.querySelector('#tour-item-nav-menu-dashboard'),
        placement: 'right',
        type: 'default',
      },
      {
        title: 'Желаем приятной дегустации!',
        description: 'Требуется помощь в приготовлении? Звоните: +7 950 951 2000, пишите: support@fitnessoft.ru',
        target: () => document.querySelector('#root'),
        placement: 'center',
        type: 'primary',
      },
    ],
  };

  const getFullPageOrder = useCallback(() => {
    return [ 
      '/service',
      '/settings/company',
      '/settings/users',
      '/settings/calendars',
      '/settings/products',
      '/settings/paymentvids',
      '/settings/rooms',
      '/settings/cards',
      '/clients',
      '/records',
      '/visits',
      '/payments',
      '/stock',
      '/dialogs',
      '/reports',
      '/'];
  }, [user]);

  const getCurrentPageSteps = () => {
    const steps = tourSteps[location.pathname] || [];
    return steps.filter((step) => {
      try {
        const target = step.target();
        return target !== null && document.contains(target);
      } catch {
        return false;
      }
    });
  };

  const finishTour = useCallback(() => {
    if (isTransitioningRef.current) return;
    dispatch(tourEnded());
    setLocalOpen(false);
  }, [dispatch]);

  const goToNextPage = useCallback(() => {
    const fullOrder = getFullPageOrder();
    const currentIndex = fullOrder.indexOf(location.pathname);

    if (currentIndex < fullOrder.length - 1) {
      const nextPath = fullOrder[currentIndex + 1];
      isTransitioningRef.current = true;
      setIsTransitioning(true);
      setLocalOpen(true);

      navigate(nextPath);

      setTimeout(() => {
        isTransitioningRef.current = false;
        setIsTransitioning(false);

        const nextPageSteps = tourSteps[nextPath] || [];
        if (nextPageSteps.length > 0) {
          dispatch(tourStepChanged(0));
        } else if (currentIndex + 1 < fullOrder.length - 1) {
          goToNextPage();
        } else {
          finishTour();
        }
      }, 700);
    } else {
      finishTour();
    }
  }, [location.pathname, navigate, dispatch, getFullPageOrder, finishTour]);

  const handleChange = useCallback((current) => {
    dispatch(tourStepChanged(current));
  }, [dispatch]);

  const handleClose = useCallback(() => {
    if (isTransitioningRef.current) return;
    dispatch(tourEnded());
    setLocalOpen(false);
  }, [dispatch]);

  useEffect(() => {
    if (isActive) {
      setLocalOpen(true);
    } else if (!isTransitioningRef.current) {
      setLocalOpen(false);
    }
  }, [isActive]);

  const [tourStartedOnce, setTourStartedOnce] = useState(false);
  useEffect(() => {
    if (isActive && !tourStartedOnce) {
      const fullOrderList = getFullPageOrder();
      if (location.pathname !== fullOrderList[0]) {
        navigate(fullOrderList[0]);
        setTourStartedOnce(true);
        setLocalOpen(true);
        setTimeout(() => dispatch(tourStepChanged(0)), 500);
      } else {
        setTourStartedOnce(true);
        setLocalOpen(true);
        dispatch(tourStepChanged(0));
      }
    } else if (!isActive) {
      setTourStartedOnce(false);
    }
  }, [isActive, navigate, dispatch, location.pathname, getFullPageOrder, tourStartedOnce]);

  useEffect(() => {
    const currentPageSteps = tourSteps[location.pathname] || [];
    const currentStepIndex = currentStep || 0;
    const step = currentPageSteps[currentStepIndex];
    
    if (step?.expandParentId && localOpen) {
      const parentEl = document.querySelector(step.expandParentId);
      if (parentEl) {
        parentEl.classList.add('tour-expanded');
      }
    } else {
      document.querySelectorAll('.nav-menu-item-parent.tour-expanded').forEach(el => {
        el.classList.remove('tour-expanded');
      });
    }
  }, [currentStep, location.pathname, localOpen]);

  const currentPageSteps = getCurrentPageSteps();
  const fullOrder = getFullPageOrder();
  const currentIndex = fullOrder.indexOf(location.pathname);
  const hasNextPage = currentIndex < fullOrder.length - 1;
  const isLastPage = currentIndex === fullOrder.length - 1;
  const currentStepIndex = currentStep || 0;
  const isLastStepOnPage = currentStepIndex === currentPageSteps.length - 1;

  const handleNext = useCallback(() => {
    if (isLastStepOnPage && hasNextPage) {
      goToNextPage();
    } else if (isLastStepOnPage && isLastPage) {
      finishTour();
    } else {
      const nextStep = currentStepIndex + 1;
      if (nextStep < currentPageSteps.length) {
        dispatch(tourStepChanged(nextStep));
      }
    }
  }, [isLastStepOnPage, hasNextPage, isLastPage, goToNextPage, finishTour, currentStepIndex, currentPageSteps.length, dispatch]);

  const getNextButtonProps = useCallback(
    (step, stepIndex) => {
      const isStepLast = stepIndex === currentPageSteps.length - 1;
      let buttonText = 'Далее';
      if (isStepLast && hasNextPage) buttonText = 'Далее';
      else if (isStepLast && isLastPage) buttonText = 'Завершить';
      return { onClick: handleNext, children: buttonText };
    },
    [currentPageSteps.length, hasNextPage, isLastPage, handleNext]
  );

  if (!user || !localOpen || currentPageSteps.length === 0) return null;

  return (
    <Tour
      ref={tourRef}
      open
      current={currentStep || 0}
      onChange={handleChange}
      onClose={handleClose}
      steps={currentPageSteps.map((step, index) => ({
        ...step,
        nextButtonProps: getNextButtonProps(step, index),
      }))}
      mask={{ style: { color: '#fff' } }}
    />
  );
};

export default AppTour;
